export function initMap() {
    if ($('#map').length) {
        setTimeout(function () {
        ymaps.ready(() => {
            let myMap = new ymaps.Map("map", {
                center: [53.220904, 50.204867], zoom: 14, controls: ['fullscreenControl',]
            }, {
                suppressObsoleteBrowserNotifier: true,
                yandexMapDisablePoiInteractivity: true,
                suppressMapOpenBlock: true
            });
            const myPlacemarks = {
                0: new ymaps.Placemark([53.220904, 50.204867], {
                    hintContent: 'ЖК Комфорт'
                }, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap.png',
                    iconImageSize: [80, 93],
                    iconImageOffset: [-40, -90],
                    zIndex: 1000
                }), 1: new ymaps.Placemark([53.219688, 50.206723], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-kindergarten.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 2: new ymaps.Placemark([53.219392, 50.209692], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-school.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 3: new ymaps.Placemark([53.216491, 50.210606], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-university.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 5: new ymaps.Placemark([53.233541, 50.200552], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-mall.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 6: new ymaps.Placemark([53.229585, 50.200716], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-park.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 7: new ymaps.Placemark([53.215639, 50.213785], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-hospital.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 8: new ymaps.Placemark([53.222910, 50.218977], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-school.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 9: new ymaps.Placemark([53.222172, 50.198996], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-kindergarten.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 10: new ymaps.Placemark([53.224307, 50.206471], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-kindergarten.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 14: new ymaps.Placemark([53.225494, 50.194214], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-university.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 15: new ymaps.Placemark([53.212822, 50.207279], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-university.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 16: new ymaps.Placemark([53.225493, 50.206612], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-school.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }),

                18: new ymaps.Placemark([53.229546, 50.217819], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-school.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 19: new ymaps.Placemark([53.214061, 50.195676], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-school.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 20: new ymaps.Placemark([53.235773, 50.212986], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-school.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 21: new ymaps.Placemark([53.238942, 50.210549], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-school.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 22: new ymaps.Placemark([53.215022, 50.207955], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-kindergarten.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 23: new ymaps.Placemark([53.217441, 50.212262], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-pool.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 24: new ymaps.Placemark([53.213487, 50.204451], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-pool.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 25: new ymaps.Placemark([53.223002, 50.191410], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-gym.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 26: new ymaps.Placemark([53.230624, 50.208264], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-gym.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 27: new ymaps.Placemark([53.220342, 50.195024], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-gym.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 28: new ymaps.Placemark([53.223700, 50.207104], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-hospital.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 29: new ymaps.Placemark([53.230814, 50.209081], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/icons/icononmap-pool.svg',
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -15]
                }), 30: new ymaps.Placemark([53.221909, 50.207038], {
                    hintContent: 'Паркинг'
                }, {
                    iconLayout: 'default#image',
                    iconImageHref: '/img/icons/icononmap-parking.png',
                    iconImageSize: [80, 93],
                    iconImageOffset: [-40, -90],
                    zIndex: 900
                }),
            };


            // myMap.behaviors.disable('scrollZoom');
            for (const key in myPlacemarks) {
                myMap.geoObjects.add(myPlacemarks[key]);
            }

            const yandexMapsButton = new ymaps.control.Button({
                options: {
                    selectOnClick: false, position: {
                        bottom: 10, right: 10
                    }, maxWidth: 250 // задаем максимальную ширину кнопки в пикселях
                }, state: {
                    // задаем минимальную ширину кнопки в пикселях
                    minWidth: 150
                }
            });

            // Добавляем HTML-разметку на кнопку
            yandexMapsButton.data.set('content', '<span style="display: inline-block; text-align: center;">Перейти на <span style="color: red;">Я</span>ндекс.Карты</span>');

            // Добавляем стили для выравнивания текста по центру
            const stylesheet = document.createElement('style');
            stylesheet.innerHTML = '.ymaps-2-1-78-button__text {display: flex; justify-content: center; align-items: center;}';
            document.head.appendChild(stylesheet);

            yandexMapsButton.events.add('click', () => {
                const center = myMap.getCenter();
                const zoom = myMap.getZoom() + 2;
                const coords = myPlacemarks[0].geometry.getCoordinates(); // получаем координаты метки
                const url = `https://yandex.ru/maps/?ll=${coords[1]},${coords[0]}&z=${zoom}&pt=${coords[1]},${coords[0]},pm2rdm`; // изменяем URL-адрес с параметром pt
                window.open(url, '_blank');
            });

            myMap.behaviors.disable('scrollZoom');
            var fullscreenControl = myMap.controls.get('fullscreenControl');
            var fullscreenControlParent = fullscreenControl;
            fullscreenControlParent.data.set({expand: false});
            if (window.innerWidth < 1000) {
                myMap.behaviors.disable('drag');

                fullscreenControl.events.add('click', function() {
                    if(fullscreenControlParent.data.get({}).expand === false){
                        fullscreenControlParent.data.set({expand: true});
                        myMap.behaviors.enable('drag');
                    } else {
                        fullscreenControlParent.data.set({expand: false});
                        myMap.behaviors.disable('drag');
                    }
                });
            }
            myMap.controls.add(yandexMapsButton);
            myMap.controls.add('zoomControl', {
                position: {
                    top: 250, right: 10
                }
            });
        })
        }, 2000);
    }

    if ($('#map_contacts').length) {
        ymaps.ready(() => {
            let myMap = new ymaps.Map("map_contacts", {
                center: [53.218869, 50.169678], zoom: 18, controls: ['fullscreenControl']
            }, {
                suppressObsoleteBrowserNotifier: true,
                yandexMapDisablePoiInteractivity: true,
                suppressMapOpenBlock: true
            });

            let myPlacemark = new ymaps.Placemark([53.219278, 50.169464], {}, {
                iconLayout: 'default#image',
                iconImageHref: '../img/icons/icononmap-sale3.svg',
                iconImageSize: [130.5, 72],
                iconImageOffset: [-70, -64],
                zIndex: 1000
            });
            let myArrow = new ymaps.Placemark([53.219109, 50.170122], {}, {
                iconLayout: 'default#image',
                iconImageHref: '../img/icons/icononmap-arrow.svg',
                iconImageSize: [70, 61],
                iconImageOffset: [0, -65.5],
                zIndex: 100
            });

            var geoJson = {
                "type": "FeatureCollection", "metadata": {
                    "name": "Без названия", "creator": "Yandex Map Constructor"
                }, "features": [{
                    "type": "Feature", "id": 0, "geometry": {
                        "type": "Polygon",
                        "coordinates": [
                            [
                                [53.21928999695935,50.16880670941605],
                                [53.21898573160552,50.16880603886357],
                                [53.21897204767176,50.168816767699425],
                                [53.21896037607187,50.1688328609535,],
                                [53.21895796125998,50.16884358978961],
                                [53.21889235875597,50.168842919237385],
                                [53.21888833405918,50.16890326894022],
                                [53.21887907725512,50.16890326894022],
                                [53.21887625996654,50.16895557201599],
                                [53.21886700316219,50.16895758367276],
                                [53.21886016117109,50.16904810822704],
                                [53.218866198222386,50.16904944933153],
                                [53.218857746353514,50.16915003216959],
                                [53.21885170930327,50.16914734996055],
                                [53.2188444648396,50.169243909485076],
                                [53.21885130683323,50.16924525058962],
                                [53.21881186475267,50.16975956416824],
                                [53.21876034850786,50.16982863105041],
                                [53.21874465213963,50.169827289945864],
                                [53.218660535608635,50.169936589963264],
                                [53.21866858504483,50.169951342112846],
                                [53.21864403425966,50.169982858068785],
                                [53.21865248617091,50.16999895132286],
                                [53.218623105710314,50.170038513905865],
                                [53.21866013313678,50.170116297967276],
                                [53.218653291114755,50.1701263562511,],
                                [53.21864886392344,50.170159213311535],
                                [53.218663352911484,50.17016122496825],
                                [53.218677439422905,50.170189388162925],
                                [53.21867623200783,50.170216880805334],
                                [53.21896762052961,50.17021553970089],
                                [53.21898371928452,50.170214869148616],
                                [53.21901269702806,50.17018000043142],
                                [53.21903241798804,50.17017798877475],
                                [53.21920628395508,50.16995201266522],
                                [53.219221980153335,50.1699453071427,],
                                [53.219232041815836,50.16993591941114],
                                [53.21924653060565,50.16990976787323],
                                [53.21924773800917,50.1698936746192,],
                                [53.21924773800917,50.16979979730367],
                                [53.2192509577395,50.169681780107034],
                                [53.21927671557324,50.16965227580786],
                                [53.21928395996804,50.169438369639025],
                                [53.21929764380857,50.169190935857436],
                                [53.21930609559022,50.169180207021334],
                                [53.219319779423614,50.16896026588215],
                                [53.219312937507475,50.16895691312084],
                                [53.21931374243884,50.16894081986676],
                                [53.21931615723286,50.16887242353691],
                                [53.219309315316124,50.16883554316295],
                                [53.21930730298745,50.16882213211786],
                                [53.21928999695935,50.16880670941605]
                            ]
                        ]
                    }
                }]
            }

            var coordinates = geoJson.features[0].geometry.coordinates[0];

            const polygonCoords = [[53.219004, 50.168805], [53.218946, 50.168837], [53.218879, 50.168837], [53.218853, 50.16896], [53.21884, 50.169148], [53.218831, 50.169395], [53.218808, 50.169749], [53.218612, 50.16998], [53.21866, 50.170221], [53.218979, 50.170221], [53.219252, 50.169921], [53.219317, 50.169009], [53.219325, 50.16881], [53.219004, 50.168805]];

            // Задаем параметры полигона
            const polygonOptions = {
                fillColor: "#000071", fillOpacity: 0.5, strokeColor: "#000071", strokeOpacity: 0.5, strokeWidth: 3
            };

            // Создаем полигон на карте
            let myPolygon = new ymaps.Polygon([coordinates], {}, polygonOptions);

            myPolygon.events.add('mouseenter', function () {
                myMap.geoObjects.add(myArrow); // добавляем объект Arrow на карту
            });

// Обработчик события mouseleave для объекта Polygon
            myPolygon.events.add('mouseleave', function () {
                myMap.geoObjects.remove(myArrow); // удаляем объект Arrow с карты
            });

            const yandexMapsButton = new ymaps.control.Button({
                options: {
                    selectOnClick: false, position: {
                        bottom: 10, right: 10
                    }, maxWidth: 250 // задаем максимальную ширину кнопки в пикселях
                }, state: {
                    // задаем минимальную ширину кнопки в пикселях
                    minWidth: 150
                }
            });

            // Добавляем HTML-разметку на кнопку
            yandexMapsButton.data.set('content', '<span style="display: inline-block; text-align: center;">Перейти на <span style="color: red;">Я</span>ндекс.Карты</span>');

            // Добавляем стили для выравнивания текста по центру
            const stylesheet = document.createElement('style');
            stylesheet.innerHTML = '.ymaps-2-1-78-button__text {display: flex; justify-content: center; align-items: center;}';
            document.head.appendChild(stylesheet);

            yandexMapsButton.events.add('click', () => {
                const center = myMap.getCenter();
                const zoom = myMap.getZoom() + 2;
                const coords = myPlacemark.geometry.getCoordinates(); // получаем координаты метки
                const url = `https://yandex.ru/maps/?ll=${coords[1]},${coords[0]}&z=${zoom}&pt=${coords[1]},${coords[0]},pm2rdm`; // изменяем URL-адрес с параметром pt
                window.open(url, '_blank');
            });

            myMap.behaviors.disable('scrollZoom');
            var fullscreenControl = myMap.controls.get('fullscreenControl');
            var fullscreenControlParent = fullscreenControl;
            fullscreenControlParent.data.set({expand: false});
            if (window.innerWidth < 1000) {
                myMap.behaviors.disable('drag');

                fullscreenControl.events.add('click', function() {
                    if(fullscreenControlParent.data.get({}).expand === false){
                        fullscreenControlParent.data.set({expand: true});
                        myMap.behaviors.enable('drag');
                    } else {
                        fullscreenControlParent.data.set({expand: false});
                        myMap.behaviors.disable('drag');
                    }
                });
            }
            myMap.controls.add(yandexMapsButton);
            myMap.controls.add('zoomControl', {
                position: {
                    top: 250, right: 10
                }
            });

            myMap.geoObjects.add(myPolygon);
            myMap.geoObjects.add(myPlacemark);
        })

    }

}
